import { useRef } from 'react';
import {
  Popover,
  PopoverTrigger,
  Center,
  PopoverContent,
  Box,
  useDisclosure,
  useOutsideClick,
} from '@chakra-ui/react';
import 'react-day-picker/dist/style.css';
import { DayPicker } from 'react-day-picker';
import dayjs from 'dayjs';
import { KText } from '@/ui-library/components';

interface DatePopOverProps {
  meta?: { value?: string };
  date?: Date | string;
  setDate?: (date: Date | undefined, onClose: () => void) => void;
  dateFormat?: string;
}

export const DatePopOver = ({
  meta = {},
  date = '',
  setDate = () => {},
  dateFormat = 'DD/MM/YYYY',
}: DatePopOverProps) => {
  const { isOpen, onToggle, onClose } = useDisclosure();
  const ref = useRef<HTMLDivElement>(null);

  useOutsideClick({
    ref,
    handler: () => {
      onClose();
    },
  });

  return (
    <Center
      ref={ref}
      w="25%"
      bg={meta?.value === 'custom' ? 'ats-primary' : undefined}
    >
      <Popover placement="bottom" isOpen={isOpen}>
        <PopoverTrigger>
          <Center flexDir="column" cursor="pointer" onClick={onToggle}>
            <KText
              size="sm-medium"
              color={meta?.value === 'custom' ? 'base-white' : 'secondary-900'}
            >
              Until
            </KText>
            <KText
              size="sm-medium"
              color={meta?.value === 'custom' ? 'base-white' : 'secondary-700'}
            >
              {date ? dayjs(date).format(dateFormat) : 'Select Date'}
            </KText>
          </Center>
        </PopoverTrigger>
        <PopoverContent>
          <Box flex="1">
            <DayPicker
              className="schedule-date-picker filter-datepicker"
              mode="single"
              numberOfMonths={1}
              selected={date ? new Date(date) : undefined}
              disabled={[new Date(), { before: new Date() }]}
              onSelect={(selected) => {
                setDate(selected, onClose);
              }}
            />
          </Box>
        </PopoverContent>
      </Popover>
    </Center>
  );
};
